import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function CustomPopover({open,handleClose,children}) {
  //   const [anchorEl, setAnchorEl] = React.useState(null);

  //   const handleClick = (event) => {
  //     setAnchorEl(event.currentTarget);
  //   };

  //   const handleClose = () => {
  //     setAnchorEl(null);
  //   };

  const popverOpen = Boolean(open);
  const id = popverOpen ? 'simple-popover' : undefined;

  return (
    <div>
      <Popover
        id={id}
        open={popverOpen}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}>
       {children}
      </Popover>
    </div>
  );
}
